<template>
  <div v-if="store.loggedIn" class="userInfo flexRowNowrapCenter ">

    <div class="userInfoHeader itemCenterCenter" style="margin-right: 15px;">
      User: {{ store.authenticatedUser.email }}
    </div>

    <div class="itemCenterCenter">
    <ModalBootstrap ModalId="signoutModal" ModalTitle="Log Out" ButtonText="" ref="logoffModal" ModalSizeClass="modal-sm">
      <template v-slot:button>
        <img @click="this.$refs.logoffModal.ShowModal();" @keydown.enter="this.$refs.logoffModal.ShowModal();" aria-label="Click to log off" tabindex="0" title="Log off" class="logoutIcon"
          src="../../assets/images/icons8-logout-50.png" height="15px;" alt="Log Off CAAMS" />
      </template>
      <template v-slot:body >
        <span class="signoutText">Are you sure you want to log off?</span>
      </template>

      <template v-slot:footer>

        <button type="button" class="btn btn-secondary" @click="this.$refs.logoffModal.HideModal();">No</button>
        <button type="button" class="btn btn-primary" data-dismiss="modal" @click="SignOut">Yes</button>

      </template>
    </ModalBootstrap>
  </div>
  </div>

  <div v-else>
    <ModalBootstrap ModalId="loginModal" ModalTitle="Log In" ButtonText="Login" ref="loginModal">
      <template v-slot:body>
          <h1></h1>
        <div class="formInputs" v-if="(loadingCac == false)">

          <div class="mb-3">
            <label for="usernameInput" class="form-label">User Name</label>
            <input type="text" class="form-control" id="usernameInput" v-model="userName" placeholder="User Name" />
          </div>

          <div class="mb-3">
            <label for="passwordInput" class="form-label">Password</label>
            <input type="password" class="form-control" id="passwordInput" v-model="password" placeholder="Password" />
          </div>

        </div>
        <div v-else>
          <LoadingGifVue></LoadingGifVue>
          <span class="w-75 float-right">(Loading CAC Card Information. Please note: It may take a few seconds for your
            Browser to Prompt you to enter your PIN)</span>
        </div>

      </template>

      <template v-slot:footer>
        <button @click="LoginWithCac" class="btn btn-primary">Log In With CAC</button>
        <button @click="LoginWithUsername" class="btn btn-primary">Log In With Username/Password</button>
        <span class="loginMessage">{{ loginMessage }}</span>
      </template>
    </ModalBootstrap>
  </div>
</template>

<script>
import $ from "jquery";
import ModalBootstrap from "../../components/dataSupport/ModalBootstrap.vue";
import { store } from "../../store/store.js";
import LoadingGifVue from "../dataSupport/LoadingGif.vue";
//import {ajaxGetAndReturn} from "@/components/helpers/utilities.js";

export default {
  name: "loginForm",
  components: {
    ModalBootstrap,
    LoadingGifVue,
  },
  data() {
    return {
      userName: "",
      password: "",
      notSubmitted: true,
      store,
      loginMessage: "",
      loadingCac: false,
    };
  },
  methods: {
    //Add new User, or Edit existing user (based on prescense of user Id)
    LoginWithUsername() {
      //console.log("Attempting to Login");
      let userData = {
        Username: this.userName,
        Password: this.password,
      };

      $.ajax({
        method: "POST",
        data: JSON.stringify(userData),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        xhrFields: {
          withCredentials: true,
        },
        url: store.webAPIUrl + "Auth/login",
        success: (result) => {
          //console.log("Log in successful! User: ", result);
          this.$refs.loginModal.HideModal();

          this.userName = "";
          this.password = "";
          this.SetAuthenticatedUserInStore(result.userProfileData, true);
        },
        error:(errorThrown)=>{
            console.log(errorThrown); 
            this.loginMessage = errorThrown.responseJSON.message;
          }
      });
    },
    SignOut() {
      $.ajax({
        method: "POST",
        contentType: "application/json; charset=utf-8",
        url: store.webAPIUrl + "Auth/Logout",
        xhrFields: {
          withCredentials: true,
        },
        success: (result) => {
          result;
          //console.log("signing user out", result);
          this.SetAuthenticatedUserInStore({}, false);
          //console.log("signing user out; authenticated user: ", store.authenticatedUser);

          this.$router.push({ name: "landing" });
        },
      });
    },
    async LoginWithCac() {

      this.loadingCac = true;

      //first request merely pings the CAC service (begins browser prompt)
      //removing this first call often resuls in timeouts while the browser prompts for the CAC PIN
      var wakeupUrl = process.env.VUE_APP_CAC_URL + "wakeup";
      console.log(process.env)
      console.log(wakeupUrl);
      $.ajax({
        method: "GET",
        url: wakeupUrl
      }).always(async (data) => {
        data;
        //no matter if that call is successful or not, continue to next request
        //it will result in an error most of the time (slow browser prompt for pin)
        //console.log("wakeup done", data);

        //now get CAC subject name/other info if needed
        var subjName = await this.GetCACInfo();
        //console.log("subject name: ",subjName);

        //if there is no subject name, stop/ display error message: 
        if (subjName == "") {
          this.loginMessage = "CAC Card was unable to be read. It is possible that an incorrect PIN was entered, or the browser prompt was cancelled. Please try closing your browser and trying again.";
          this.loadingCac = false;
          return false;
        }

        //check CAC subject against DB/ backend project this time
        $.ajax({
          method: "POST",
          data: subjName,
          contentType: "application/json; charset=utf-8",
          dataType: "json",
          xhrFields: {
            withCredentials: true,
          },
          url: store.webAPIUrl + "Auth/LoginCac?subjectName=" + subjName,
          success: (result) => {
            //console.log("Log in successful!");
            this.$refs.loginModal.HideModal();

            this.userName = "";
            this.password = "";
            this.SetAuthenticatedUserInStore(result.userProfileData, true);
            this.loadingCac = false;
          },
          error:(errorThrown)=>{
            this.loadingCac = false;
            console.log(errorThrown); 
            this.loginMessage = errorThrown.responseJSON.message; 
          }
        });
      });

    },
    async GetCACInfo() {
      var subjName = "";
      var cacURL = process.env.VUE_APP_CAC_URL;
      await $.ajax({
        method: "GET",
        url: cacURL,
        success: (result) => {
          if (result.commonName != "") {
            subjName = result.commonName;
            //console.log(subjName);
          }
        },
        error: (errorThrown) => {
          errorThrown;
          //console.log(errorThrown);
        },
      });
      //when the subject name is returned, check login status with the CAC (matching CAC subject name to an existing user)
      return subjName;
    },
    CheckLoginStatusServer() {
      $.ajax({
        method: "GET",
        url: store.webAPIUrl + "Auth/GetCurrentLoginStatus",
        xhrFields: {
          withCredentials: true,
        },
        contentType: "application/json; charset=utf-8",
        success: (result) => {
          //console.log("check login status results: ",result);
          if (result.loggedIn) {
            this.SetAuthenticatedUserInStore(result.userProfileData, true);
          }

        },
        error: () => {
          // console.log('LoginForm Exception: errorThrown = ', errorThrown);
        },
      });

    },
    SetAuthenticatedUserInStore(userProfileData, loggedIn) {
      store.authenticatedUser = userProfileData;
      // console.log("setting authenticated user object: ", store.authenticatedUser);
      store.loggedIn = loggedIn;
      //console.log("store logged in? ", store.loggedIn);
    }
  },
  watch: {
    $route(to, from) {
      to; from;
      //console.log("changed route to: ", to, "; from: ", from);
      //this.CheckLoginStatusServer();
    }
  }
};
</script>

<style>

.flexRowNowrapCenter {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.itemCenterCenter {
  display: flex;
  align-items: center;
  justify-content: center;
}

    .errorMsg {
        color: #DC143C;
    }

.logoutIcon {
  margin-left: 10px;
  margin-right: 10px;
  width: 15px;
  height: 15px;
  cursor: pointer;
}

.userInfo {
  color: white;
}

    .loginMessage {
        text-align: left;
        color: #DC143C;
        font-style: italic;
    }
.signoutText{
  color:black;
}
</style>
